import {
  ADD_SUB_BUSINESS,
  ADD_SUB_BUSINESS_PAYMENT_METHOD_FAILED,
  ADD_SUB_BUSINESS_PAYMENT_METHOD_SUCCESS,
  ADDING_SUB_BUSINESS_PAYMENT_METHOD,
  CREATE_SUB_BUSINESS_FAILED,
  CREATE_SUB_BUSINESS_SUCCESS,
  CREATING_SUB_BUSINESS,
  DELETE_SUB_BUSINESS_PAYMENT_METHOD_FAILED,
  DELETE_SUB_BUSINESS_PAYMENT_METHOD_SUCCESS,
  DELETING_SUB_BUSINESS_PAYMENT_METHOD,
  FETCH_SUB_BUSINESS_FAILED,
  FETCHING_SUB_BUSINESS,
  LogoutActionTypes,
  RESET_UPDATE_SUB_BUSINESS_PAYMENT_METHOD_STATE,
  SubBusinessDataTypes,
  UPDATE_SUB_BUSINESS_FAILED,
  UPDATE_SUB_BUSINESS_SUCCESS,
  UPDATING_SUB_BUSINESS,
} from '../config/ActionTypes';
import { SubBusiness, SubBusinessState } from '../config/types';

export const initialState: SubBusinessState = {
  loadingSubBusiness: false,
  subBusinesses: null,
  subBusinessErrorMessage: null,
  creatingSubBusiness: false,
  createSubBusinessSuccess: false,
  createSubBusinessErrorMessage: null,
  updatingSubBusiness: false,
  updateSubBusinessSuccess: false,
  updateSubBusinessErrorMessage: null,
  deletingSubBusiness: false,
  deleteSubBusinessSuccess: false,
  deleteSubBusinessErrorMessage: null,
  addingSubBusinessPaymentMethod: false,
  addSubBusinessPaymentMethodSuccess: false,
  addSubBusinessPaymentMethodErrorMessage: null,
  deletingSubBusinessPaymentMethod: false,
  deleteSubBusinessPaymentMethodSuccess: false,
  deleteSubBusinessPaymentMethodErrorMessage: null,
};

export function subBusinessReducer(
  state = initialState,
  action: SubBusinessDataTypes | LogoutActionTypes,
): SubBusinessState {
  switch (action.type) {
    case FETCHING_SUB_BUSINESS:
      return {
        ...state,
        loadingSubBusiness: true,
        subBusinesses: null,
        subBusinessErrorMessage: null,
      };

    case ADD_SUB_BUSINESS:
      return {
        ...state,
        loadingSubBusiness: false,
        subBusinesses: action.subBusiness,
        subBusinessErrorMessage: null,
      };

    case CREATING_SUB_BUSINESS:
      return {
        ...state,
        creatingSubBusiness: true,
        createSubBusinessSuccess: false,
        createSubBusinessErrorMessage: null,
      };

    case CREATE_SUB_BUSINESS_SUCCESS:
      const newSubBusiness = state.subBusinesses ? [...state.subBusinesses] : [];
      newSubBusiness.push({ ...action.subBusiness });

      return {
        ...state,
        subBusinesses: newSubBusiness,
        creatingSubBusiness: false,
        createSubBusinessSuccess: true,
        createSubBusinessErrorMessage: null,
      };

    case CREATE_SUB_BUSINESS_FAILED:
      return {
        ...state,
        creatingSubBusiness: false,
        createSubBusinessSuccess: false,
        createSubBusinessErrorMessage: action.error,
      };

    case FETCH_SUB_BUSINESS_FAILED:
      return {
        ...state,
        loadingSubBusiness: false,
        subBusinesses: null,
        subBusinessErrorMessage: action.error,
      };

    case UPDATING_SUB_BUSINESS:
      return {
        ...state,
        updatingSubBusiness: true,
        updateSubBusinessSuccess: false,
        updateSubBusinessErrorMessage: null,
      };

    case UPDATE_SUB_BUSINESS_SUCCESS:
      let updatedSubBusiness = state.subBusinesses!.map((s) => {
        if (s.id === action.subBusiness.id) {
          let returnedSubBusiness: SubBusiness = {
            ...s,
            name: action.subBusiness.name,
            status: action.subBusiness.status,
          };

          return returnedSubBusiness;
        }

        return s;
      });

      return {
        ...state,
        updatingSubBusiness: false,
        updateSubBusinessSuccess: true,
        subBusinesses: updatedSubBusiness,
        updateSubBusinessErrorMessage: null,
      };

    case ADDING_SUB_BUSINESS_PAYMENT_METHOD:
      return {
        ...state,
        addingSubBusinessPaymentMethod: true,
        addSubBusinessPaymentMethodSuccess: false,
        addSubBusinessPaymentMethodErrorMessage: null,
      };

    case ADD_SUB_BUSINESS_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        addingSubBusinessPaymentMethod: false,
        addSubBusinessPaymentMethodSuccess: true,
        addSubBusinessPaymentMethodErrorMessage: null,
      };

    case ADD_SUB_BUSINESS_PAYMENT_METHOD_FAILED:
      return {
        ...state,
        addingSubBusinessPaymentMethod: false,
        addSubBusinessPaymentMethodSuccess: false,
        addSubBusinessPaymentMethodErrorMessage: action.error,
      };

    case DELETING_SUB_BUSINESS_PAYMENT_METHOD:
      return {
        ...state,
        deletingSubBusinessPaymentMethod: true,
        deleteSubBusinessPaymentMethodSuccess: false,
        deleteSubBusinessPaymentMethodErrorMessage: null,
      };

    case DELETE_SUB_BUSINESS_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        deletingSubBusinessPaymentMethod: false,
        deleteSubBusinessPaymentMethodSuccess: true,
        deleteSubBusinessPaymentMethodErrorMessage: null,
      };

    case DELETE_SUB_BUSINESS_PAYMENT_METHOD_FAILED:
      return {
        ...state,
        deletingSubBusinessPaymentMethod: false,
        deleteSubBusinessPaymentMethodSuccess: false,
        deleteSubBusinessPaymentMethodErrorMessage: action.error,
      };

    case UPDATE_SUB_BUSINESS_FAILED:
      return {
        ...state,
        updatingSubBusiness: false,
        updateSubBusinessSuccess: false,
        updateSubBusinessErrorMessage: action.error,
      };

    case RESET_UPDATE_SUB_BUSINESS_PAYMENT_METHOD_STATE:
      return {
        ...state,
        addingSubBusinessPaymentMethod: false,
        addSubBusinessPaymentMethodSuccess: false,
        addSubBusinessPaymentMethodErrorMessage: null,
        deletingSubBusinessPaymentMethod: false,
        deleteSubBusinessPaymentMethodSuccess: false,
        deleteSubBusinessPaymentMethodErrorMessage: null,
      };

    default:
      return state;
  }
}
